import gsap from 'gsap';
import CustomEase from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Sizes } from '../utils';
gsap.registerPlugin( CustomEase, ScrollTrigger );

// pending
export class MatrixScroll {
	constructor( selector, options = {} ) {
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
		};
		this.isEnable = false;

		this.allItems = [];
	}

	init() {
		if (
			! this.elements?.length ||
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		this.elements.forEach( ( ele, index ) => {
			this.allItems[ index ] = gsap.utils.toArray(
				this.options.child,
				ele
			);
			const triggerVars = {};
			if (
				this.options.viewIn?.animationTweens &&
				this.options.viewIn.animationTweens.length
			) {
				const onEnterCallbacks = [];
				this.options.viewIn.animationTweens.forEach( ( tween ) => {
					const generalProps = {
						duration: tween.duration || 0.5,
					};
					if ( tween.delay ) {
						generalProps.delay = tween.delay;
					}
					if ( tween.customEase ) {
						generalProps.ease = CustomEase.create(
							'custom',
							tween.customEase
						);
					} else if ( tween.ease ) {
						generalProps.ease = tween.ease;
					} else {
						generalProps.ease = 'power1.inOut';
					}
					if ( tween.stagger ) generalProps.stagger = tween.stagger;
					switch ( tween.method ) {
						case 'set':
							onEnterCallbacks.push( ( elements ) => {
								gsap.set( elements, { ...tween.to } );
							} );
							break;
						case 'from':
							onEnterCallbacks.push( ( elements ) => {
								gsap.from( elements, {
									...generalProps,
									...tween.to,
								} );
							} );
							break;
						case 'fromTo':
							onEnterCallbacks.push( ( elements ) => {
								gsap.fromTo( elements, tween.from, {
									...generalProps,
									...tween.to,
								} );
							} );
							break;
						default:
							onEnterCallbacks.push( ( elements ) => {
								if ( tween.child ) {
									const temp = [];
									elements.forEach( ( item ) => {
										const target = item.querySelector(
											tween.child
										);
										temp.push( target );
									} );
									elements = temp;
								}
								gsap.to( elements, {
									...generalProps,
									...tween.to,
								} );
							} );
					}
				} );
				triggerVars.onEnter = ( elements ) => {
					onEnterCallbacks.forEach( ( callback ) => {
						callback( elements );
					} );
				};
			}
			if (
				this.options.viewOut?.animationTweens &&
				this.options.viewOut.animationTweens.length
			) {
				triggerVars.onLeave = ( elements ) => {
					gsap.to( elements, { opacity: 0, stagger: 0.15 } );
				};
			}
			if ( this.options.start ) triggerVars.start = this.options.start;
			if ( this.options.end ) triggerVars.end = this.options.end;
			ScrollTrigger.batch( this.allItems[ index ], {
				...triggerVars,
			} );
		} );
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		this.elements.forEach( ( ele, index ) => {
			ScrollTrigger.getAll().forEach( ( trigger ) => {
				if ( trigger.trigger === ele ) {
					ScrollTrigger.clearMatched( trigger );
				}
			} );
			this.allItems[ index ].forEach( ( item ) => {
				gsap.killTweensOf( item );
				gsap.set( item, { clearProps: 'all' } );
			} );
		} );
		this.allItems = [];
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.allItems = null;
		this.isEnable = null;
	}
}
